import React from "react";
import BorderCard from "../components/BorderCard";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import SequenceWorkFlowSteps from "./SequenceWorkFlowSteps";
import { useCampaignId } from "@/features/campaigns/hooks/useCampaignId";
import { useNavigate } from "react-router-dom";
import { Pen } from "lucide-react";
import CardTitle from "../components/CardTitle";

const AnalyticsStepArea = () => {
  const navigate = useNavigate();
  const campaignId = useCampaignId();
  const handleEditSteps = () => {
    navigate(`/campaigns/${campaignId}/campaignsteps`);
  };
  return (
    <div className="flex w-[45%] min-h-0 min-w-0 flex-col">
      <BorderCard>
        <CardTitle text={"Sequence Steps"} />
        <SecondaryButton
          title={"Edit Steps"}
          icon={<Pen size={16} className="text-gray-700 dark:text-gray-300" />}
          onClick={handleEditSteps}
        />
      </BorderCard>
      <BorderCard variant="bottom" bg={true} className="min-h-0 flex-1">
        <div className="h-full overflow-auto scrollbar-hide w-full">
          <SequenceWorkFlowSteps />
        </div>
      </BorderCard>
    </div>
  );
};

export default AnalyticsStepArea;
